import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import CustomWsAttrConst from './constants/customAttributes.constants';
import CustomWsAttrReducers from './reducers/customAttributes.reducers';
import * as CustomWsAttrActions from './actions/customAttributes.actions';
import CustomWorkstreamsAttr from './components/customWsAttributes.component';


const mapsStateToPropsForCustomWsAttr = state => ({
  CustomAttr: state,

});

const mapsDispatchToPropsForCustomWsAttr = dispatch => ({
  actions: bindActionCreators(CustomWsAttrActions, dispatch),
});


const CustomWsAttrAppComp = connect(
  mapsStateToPropsForCustomWsAttr,
  mapsDispatchToPropsForCustomWsAttr,
)(CustomWorkstreamsAttr);


const initCustomWsAttrComp = function (data) {
  const CustomWsAttrStore = createStore(CustomWsAttrReducers, data);
  ReactDOM.render(
    <Provider store={CustomWsAttrStore}>
      <CustomWsAttrAppComp />
    </Provider>,
    document.getElementById('customWorkstreamAttributes'),
  );
};


window.initCustomWsAttrComp = initCustomWsAttrComp;
